<template lang="pug">
  // this component should not be used by it's own
  // it's meant to be extended
  .page
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'Contentpage',
  computed: {
    areas() {
      let areas = {};
      this.sections.map(section => {
        const key = section.area || 'main';
        if (!areas[key]) areas[key] = [];
        areas[key].push(section);
      });
      return areas;
    },
    ...mapGetters({
      sections: 'sections'
    })
  }
};
</script>
